'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = UICaret;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _IconConstants = require('../IconConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function UICaret(_ref) {
  var altText = _ref.altText,
      className = _ref.className,
      color = _ref.color,
      strokeWidth = _ref.strokeWidth,
      viewBoxHeight = _ref.viewBoxHeight,
      viewBoxWidth = _ref.viewBoxWidth,
      width = _ref.width,
      rest = _objectWithoutProperties(_ref, ['altText', 'className', 'color', 'strokeWidth', 'viewBoxHeight', 'viewBoxWidth', 'width']);

  var viewBox = '0 0 ' + viewBoxWidth + ' ' + viewBoxHeight;
  return _react2.default.createElement(
    'svg',
    _extends({}, rest, {
      className: (0, _classnames2.default)('private-icon-caret', className),
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: viewBox,
      width: width
    }),
    _react2.default.createElement(
      'title',
      null,
      altText
    ),
    _react2.default.createElement('path', {
      className: 'private-icon-caret__inner',
      d: 'M2 2l7.5 8.5-7.4 8.6',
      fill: 'none',
      stroke: color,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeWidth: strokeWidth
    })
  );
}

UICaret.defaultProps = {
  strokeWidth: 4,
  viewBoxHeight: _IconConstants.CARET_HEIGHT,
  viewBoxWidth: _IconConstants.CARET_WIDTH
};

UICaret.propTypes = {
  altText: _propTypes2.default.string,
  color: _propTypes2.default.string,
  strokeWidth: _propTypes2.default.number,
  viewBoxHeight: _propTypes2.default.number,
  viewBoxWidth: _propTypes2.default.number,
  width: _propTypes2.default.number
};

UICaret.displayName = 'UICaret';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/icon/icons/UICaret.js
// module id = 597
// module chunks = 177